document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header');
  if (!header) return;

  // Get all sections with header color data attribute
  const sections = document.querySelectorAll('[data-header-color]');
  if (sections.length === 0) return;

  // Default color (fallback)
  const defaultColor = getComputedStyle(header).getPropertyValue('--color-foreground').trim() || '#000000';
  
  // Store active section and its color
  let activeSection = null;
  let activeColor = defaultColor;

  // Function to update header color
  function updateHeaderColor(color) {
    if (color && color !== activeColor) {
      header.style.setProperty('--header-text-color', color);
      activeColor = color;
    }
  }

  // Function to check which section is currently under the header
  function checkSectionUnderHeader() {
    // Get header position and height
    const headerRect = header.getBoundingClientRect();
    const headerBottom = headerRect.bottom;
    
    // The header is fixed, so we check what section is directly under it
    // We check the area just below the header to see which section is there
    const checkY = headerBottom; // Position just below the header
    
    let sectionUnderHeader = null;
    let sectionUnderHeaderColor = defaultColor;

    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top;
      const sectionBottom = rect.top + rect.height;
      
      // Check if the check point (just below header) overlaps with this section
      // We check if the header bottom is within the section's vertical bounds
      if (checkY >= sectionTop && checkY <= sectionBottom) {
        sectionUnderHeader = section;
        sectionUnderHeaderColor = section.getAttribute('data-header-color') || defaultColor;
      }
    });

    // Update header color if a different section is now under the header
    if (sectionUnderHeader !== activeSection) {
      activeSection = sectionUnderHeader;
      updateHeaderColor(sectionUnderHeaderColor);
    }
  }

  // Use scroll event to check which section is under the header
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkSectionUnderHeader();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Also use Intersection Observer to detect when sections enter/exit the header area
  const observerOptions = {
    root: null,
    rootMargin: `-${header.getBoundingClientRect().bottom}px 0px 0px 0px`, // Offset by header height
    threshold: [0, 0.1, 0.5, 1.0]
  };

  const observer = new IntersectionObserver((entries) => {
    // When intersection changes, check which section is under header
    checkSectionUnderHeader();
  }, observerOptions);

  // Observe all sections
  sections.forEach(section => {
    observer.observe(section);
  });

  // Listen to scroll events
  window.addEventListener('scroll', onScroll, { passive: true });

  // Initial check
  checkSectionUnderHeader();
});

